import React from "react";
import "../../css/toastView.css";
import Heading from "../../components/Heading";
import ContentPage from "../../components/content-page";
import Meta from "../../components/meta";
import PropTypes from "prop-types";
import ReactPixel from "react-facebook-pixel";
import Link from "gatsby-link";
import Modal from "../../components/Modal";
import Slider from "react-slick";
import "../../components/slick.css";
import "../../components/slick-theme.css";
import LinkedInTag from "react-linkedin-insight";
const icon1 = "https://winpeforum.com/assets/elements/Sarika-Saxena-img-1.jpg";
const icon2 = "https://winpeforum.com/assets/elements/sunilgoyal.jpg";
const icon3 = "https://winpeforum.com/assets/elements/yourstory-press-nupur-garg.jpg";
 
let duration = 400;
 

const I1 = "https://www.winpeforum.com/assets/sheshines/17feb2026/1.png";
const I2 = "https://www.winpeforum.com/assets/sheshines/17feb2026/2.png";
const I3 = "https://www.winpeforum.com/assets/sheshines/17feb2026/3.png";
const I4 = "https://www.winpeforum.com/assets/sheshines/17feb2026/4.png";
const I5 = "https://www.winpeforum.com/assets/sheshines/17feb2026/5.png";
const I6 = "https://www.winpeforum.com/assets/sheshines/17feb2026/6.png";
const I7 = "https://www.winpeforum.com/assets/sheshines/17feb2026/7.png";
const I8 = "https://www.winpeforum.com/assets/sheshines/17feb2026/8.png";
 
 
 
 

const II1 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/1.png";
const II2 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/2.png";
const II3 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/3.png";
const II4 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/4.png";
const II5 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/5.png";
const II6 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/6.png";
const II7 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/7.png";
const II8 = "https://www.winpeforum.com/download.php?file=assets/sheshines/17feb2026/8.png";
 
 

const TeamModal = ({ activeItem, show, onHide }) => {
  return (
    <Modal
      direction=""
      className="teamdetails__wrapper"
      show={show}
      onHide={onHide}
    >
      <Modal.Header>
        <div className="head_section">
          <span className="item_name">{activeItem.name}</span>
          <div
            className="item_des"
            dangerouslySetInnerHTML={{ __html: activeItem.post }}
          ></div>
        </div>
        <span className="cross pull-right">
          <i onClick={onHide} className="fa fa-times" />
        </span>
      </Modal.Header>
      <Modal.Body>
        <div className="item__desc">
          <div dangerouslySetInnerHTML={{ __html: activeItem.desc }}></div>
        </div>
      </Modal.Body>
      <Modal.Footer />
    </Modal>
  );
};

TeamModal.propTypes = {
  activeItem: PropTypes.object,
  show: PropTypes.object,
  onHide: PropTypes.object,
};

export class SheShines extends React.Component {
  constructor(args) {
    super(args);
    this.state = {
      slidesToShow: 1,
      activeItem: {},
      isShow: false,
      defaultStyle: {
        transition: `opacity ${duration}ms ease-in-out`,
        opacity: 0,
      },
    };
     
    this.Speaker1 = [
 
       
 {
            imgUrl: icon1,
            desc: `<div>
       Sarika Saxena is the Managing Partner at IAN Alpha Fund, an offshoot of the Indian Angel
Network, with over 25 years of experience across Indian, UK, and US markets. She has spent
over 20 years in the start-up, PE, and VC space.<Br/><Br/>
Her expertise includes M&amp;A (heading M&amp;A at Mphasis), cross-border transactions, debt &amp;
equity, and fund raising, notably raising $42m for Value Based Housing Corporation. Sarika
also played a pivotal role in establishing the innovative NBFC, Nfin. She holds an MBA from
the London Business School.


            </div>`,
            name: "Sarika Saxena",
            post: `<div>Managing Partner<br/> Indian Angel Network

 
     
            </div>`,
          },

      
      {
            imgUrl: icon2,
            desc: ` Sunil K. Goyal co-founded YourNest, an early-stage venture fund, in 2011, and he now manages a US$ 100 million fund corpus across three funds. YourNest invests in Indian technology startups that create innovative products for global markets. Sunil believes in conscious capitalism’ and relishes driving businesses with a high sense of purpose and vision. He had played a pivotal role in Dabur and Airtel before launching YourNest. Startups
gain from his experiences in building businesses from the early stage to leading business transformation. He is a qualified CFA, Cost Accountant with a master’s in business economics from the University of Delhi.
`,
            name: "Sunil Goyal",
            post: `<div>Managing Director & Fund Manager<br/> YourNest Venture Capital

 
            </div>`,
          },
 
  {
            imgUrl: icon3,
            desc: `<div>Nupur Garg is a leading investor in private equity and venture capital and an expert advisor to large institutional investors. She is the founder of Winpe (https://winpeforum.com), an initiative to enhance gender diversity in the investing ecosystem.<br/><br/>
    
    
    Nupur serves as Chairperson of the board of Kids Clinic India Limited and an independent director on the boards of companies including Edelweiss Real Assets Managers Limited, Kerala Infrastructure Fund Management Limited and SIDBI, the Indian development finance institution. She is an independent member of the investment committee at the Fund of Funds managed by the National Investment and Infrastructure Fund (NIIF), the quasi-sovereign wealth fund sponsored by the government of India, and an advisor to and a member of the investment committee for the Dutch Good Growth Fund (DGGF) investment funds mandate given by the Dutch government for investments in SMEs in frontier markets across 75 countries. She has served as an external expert on the investment committee for the INR 10,000 crore Fund of Fund for Start-ups for investing in the Indian start-up ecosystem. Nupur advises select fund managers on a confidential basis on matters related to institutionalization, best practices and governance. She also mentors female entrepreneurs across various platforms.
    <br/><br/>
    
    Nupur is recognized as a thought and industry leader with a long list of recognitions that include the
    HerPower Award 2023, BW VC World Most Influential Women 2023 and 2022, Forbes W-Power list of
    Self Made Women 2020, India’s top 10 Women Leaders in Finance (AIWMI 2019), Vedica Women’s
    Alliance’s Women Leader in D&I 2022, Women Empowerment Entrepreneur Award 2019-20 and the
    Business Excellence and Innovative Best Practices - Academia Award 2019.
    <br/><br/>
    
    Prior to starting her entrepreneurial journey, Nupur led the private equity and venture capital funds
    business in the region for IFC and is widely credited with establishing IFC’s brand and credibility as one
    of the most respected institutional investors in this space. Under her stewardship, the portfolio doubled in
    size and returns, moving from a negative IRR to delivering gains for the first time in its history.
    <br/><br/>
    
    Nupur is a CA and an MBA from MIT Sloan School of Management, with executive education from
    Harvard Business School.
    
    <br/><br/>
    Nupur loves to spend time with her mother, husband and 8-year-old son, travel to new places, read and
    do 1500-piece puzzles.</div> `,
            name: "Nupur Garg",
            post: `<div>Founder<br/> Winpe


 
            </div>`,
          },

      
    ];

    this.Speaker2 = [
       
      
    

      
    ];
    this.CollegiumsImages = [
        { id:23, ImgSrc: I1, ImgSrc1: II1,},   
        { id:35, ImgSrc: I2, ImgSrc1: II2,},   
        { id:22, ImgSrc: I3, ImgSrc1: II3,},   
        { id:19, ImgSrc: I4, ImgSrc1: II4,},  
        { id:35, ImgSrc: I5, ImgSrc1: II5,},   
        { id:34, ImgSrc: I6, ImgSrc1: II6,},  
        { id:23, ImgSrc: I7, ImgSrc1: II7,},   
        { id:35, ImgSrc: I8, ImgSrc1: II8,},   
 
   
    
    ];
  
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    ReactPixel.init("2879175222167037");
    ReactPixel.track("ViewContent", location);
    LinkedInTag.init("2117884");
    LinkedInTag.track("2310748");
    setTimeout(() => {
      this.setState({
        defaultStyle: {
          transition: `opacity ${duration}ms ease-in-out`,
          opacity: 1,
        },
      });
    }, 500);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const { slidesToShow } = this.state;
    // // console.log("width", window.innerWidth)
    if (window.innerWidth <= 768 && window.innerWidth > 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else if (window.innerWidth <= 500) {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    } else {
      if (slidesToShow !== 1) {
        this.setState({
          slidesToShow: 1,
        });
      }
    }
  };
  togglePopUp = (item) => {
    this.setState({
      isShow: !this.state.isShow,
      activeItem: item || {},
    });
  };
  render() {
    const { defaultStyle, isShow, slidesToShow } = this.state;
    const { location } = this.props;
    let settings = {
      dots: false,
      infinite: true,
      speed: 6000,
      autoplay: true,
      slidesToShow: slidesToShow,
      slidesToScroll: slidesToShow,
      autoplaySpeed: 7000,
      arrows: true,
    };
    console.log("render", this.render1, slidesToShow);
    this.render1 = this.render1 + 1;
    return (
      <ContentPage>
        <Meta
          title="sheshines with Winpe"
          image={"https://winpeforum.com/assets/elements/sheshineswebpage1.png"}
          description="Winpe's first in-person networking event for women in investing and entrepreneurship was welcomed with high enthusiasm and energy and demands for more such sessions! "
          location={location}
        />
        <div className="section__content" style={defaultStyle}>
          <div className="toastshine_wrapper">
            <div className="back_event">
              <Link to="/events/">
                <i className="fa fa-arrow-left">Back to Events</i>
              </Link>
            </div>
            <div className="toastshine_section">
              <div className="m_heading">Winpe sheshines | February 17, 2026 
 </div>
              <div className="r_btm"></div>
               
 
              <div className="date_heading">
                <div className="date_heading">
                <span> sheshines Delhi: When Things Don’t Go to Plan — <br/>Pivots, Shutdowns, Down-Rounds & Difficult Conversations

</span> <br/><br/>
                  <span>February 17, 2026 (5:00 - 8:00 PM IST)</span>
                  <br/>
                  <span> <i>Jaypee Vasant Continental, New Delhi 
</i></span>
                </div>
              </div>
              <br/>     
              
              <div className="top_text" style={{textAlign:'justify'}}>
      On 17th February 2026, sheshines Delhi gathered founders and investors at Jaypee Vasant Continental, New Delhi, for a deeply honest conversation on the less-discussed side of entrepreneurship and investing - the moments of uncertainty, recalibration, and hard choices. The session moved beyond success stories to focus on what happens when growth stalls, assumptions break, and leaders are forced to rethink their path forward.<br/>
      <br/>
Designed as a forum for candid learning and peer exchange, sheshines by Winpe creates trusted spaces where women founders and investors share real experiences, strengthen networks, and collectively build resilience within the investing ecosystem.



 <br/><br/>
 <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Event Highlights</h2>          <div class="r_btm"></div>

What set this session apart was its scenario-led format, which placed participants in realistic, high-pressure situations—from negotiating down rounds to deciding when to pivot or shut down. These case-based discussions encouraged practical thinking and revealed how values, judgment, and communication styles surface most clearly during adversity.<br/><br/>
Rather than offering prescriptive answers, the speakers focused on how leaders process setbacks, balance competing stakeholder interests, and maintain credibility in turbulent phases. Founders in the room reflected on navigating personal doubt and external pressure, while investors shared how they evaluate leadership maturity during difficult cycles.<br/><br/>
The dialogue emphasized that challenging phases are not merely operational hurdles, but defining moments that shape long-term reputation, trust, and leadership legacy.




<br/> <br/>

    <div className="row"> 
                          

                  <div className="col-md-12">   

                  <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Speakers & Moderator</h2>          <div class="r_btm"></div>
                      
                 
                     
                      <div className="Our_Speakers container">
                                <center>
                                  <div className="Speakers_img" style={{ width: '100%', margin:'0' }}>
                                    <div className="row">
        
                                      {this.Speaker1.map((item, i) => {
                                       if(i<=10) 
                                       {
                                        return (
                                          <div
                                            className="main_speaker_card col-md-4 col-sm-12 col-lg-4"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                       }
                                       else 
                                       return (
                                          <div
                                            className="main_speaker_card col-md-3 col-sm-12 col-lg-3"
                                            key={i}
                                          >
                                            <div className="Scardd">
                                              <div
                                                className="s_img"
                                                onClick={() => this.togglePopUp(item)}
                                              >
                                                 <center>  <img
                                                  src={item.imgUrl}
                                                  alt={item.name}
                                                  className="img-responsive"
                                                  style={{ borderRadius: '50%', width: '150px', height: '150px', objectFit: 'cover' }}
                                                />
                                                </center>
                                              </div>
                                              <br />    <div
                                                className="Speakers_name"
                                                dangerouslySetInnerHTML={{ __html: item.name }}
                                              ></div>
                                              <div
                                                className="Speakers_post"
                                                dangerouslySetInnerHTML={{ __html: item.post }}
                                              ></div>
                                            </div>
                                          </div>
                                        );
                                      })}
                                    </div>
                                  </div>
        
                                </center>
                              </div>
        </div>
        
                
</div> 



<br/>
 

<br/><br/>
 <h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>Key Takeaways </h2>    
   <div class="r_btm"></div>

<ul>
<li><b>Resilient Leadership Over Reactive Decisions</b> 
<br/>
Strong leaders respond to adversity with clarity and composure, using data and perspective rather than emotion to guide critical choices.



</li>
 <li><b>Adaptability and Coachability Matter
</b> 
<br/>
Founders who remain open to feedback, adapt quickly, and build on insights - rather than defending ego - are better positioned to navigate downturns.



</li>
<li><b>Emotional Maturity Is a Core Leadership Skill</b> 
<br/>
Handling uncertainty, disappointment, and pressure with emotional intelligence strengthens teams and investor relationships.


</li>
<li><b>Capital Discipline and Transparency Are Non-Negotiable
</b> 
<br/>
Investors emphasized the importance of responsible capital deployment, clear reporting, and honesty - especially in difficult phases.

</li>
<li><b>Prepare for Dilution and Changing Outcomes
</b> 
<br/>
Founders must be mentally and strategically prepared for dilution, pivots, and evolving roles as companies grow and restructure.
</li>

<li><b>Separate Identity from Outcomes
</b> 
<br/>
 Personal self-worth should not be tied solely to venture success. Healthy detachment enables better decision-making and long-term resilience.

</li>
 
 <li><b>Exit with Dignity When Needed

</b> 
<br/>
Knowing when and how to wind down responsibly is a sign of leadership. Preserving integrity, team welfare, and stakeholder trust matters deeply.
</li>

<li><b>Trust Is Built in Adversity
</b> 
<br/>
The toughest moments often define relationships. Trust grows through honest communication, data-driven choices, and the courage to confront hard realities.


</li>
 
</ul>
 <br/>

<h2 class="ignite-ask-me-anything__heading" style={{ fontSize: "30px" }}>A Session of Reflection and Strength</h2>



 <p>The evening encouraged founders to confront difficult truths without losing optimism or integrity. Investors, in turn, shared the responsibilities they carry towards LPs, teams, and the broader ecosystem - highlighting the shared accountability that underpins sustainable entrepreneurship.<br/><br/>
The open exchange fostered empathy, mutual respect, and practical clarity, leaving participants better equipped to face uncertainty with confidence and composure.<br/><br/>
As with every sheshines edition, this session reinforced Winpe’s commitment to building inclusive, supportive platforms where women entrepreneurs and investors can learn from real experiences, strengthen networks, and grow together within the PE–VC ecosystem.


</p>
 
 

 

              </div>
              <br />

              <br />
             

             
              <div className="container">
                    <div>
                      <Heading title="Gallery" />
                    </div>
                    <div className="row">
                      {this.CollegiumsImages.map((item, j) => {
                        return (
                          <div className="col-lg-4 col-md-4 col-sm-6 col-xs-12" style={{padding: '8px'}}>
                            <div className="img_card">
                            <img style={{width:'100%'}} src={item.ImgSrc} alt="Winpe sheshines" />
                            <a href={item.ImgSrc1} > <i style={{color:'white', position:'absolute', left:'20px', top:'20px'}} class="fa fa-2x  fa-download "></i></a> 
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                 <br/>
  <br/> 
    
       
          <br/><br/>
     
            </div>
            <TeamModal
              show={isShow}
              onHide={this.togglePopUp}
              activeItem={this.state.activeItem}
            />
          </div>
        </div>
      </ContentPage>
    );
  }
}

SheShines.propTypes = {
  location: PropTypes.object,
};

export default SheShines;



// WEBPACK FOOTER //
// ./src/pages/sheshines17Feb2026/index.js